import domtoimage from 'dom-to-image-more';

export const PdfExportElevationImage = async (pdf, pdfWidth, startY) => {  
    const elevationNode = document.getElementById("elevationGraphWrapper");

    //TODO: Show the waypoint names, then hide
    //document.querySelectorAll(".waypointsSvgLabels")[0].querySelectorAll("text").forEach((wptlabel) => {wptlabel.style.visibility = "visible";})
    
    await domtoimage.toPng(elevationNode)
    .then(function (dataUrl) {
        const imgProps = pdf.getImageProperties(dataUrl);
        console.log(`imgProps: ${imgProps}`);

        pdf.addImage(dataUrl, 0, startY, pdfWidth, pdfWidth * (imgProps.height/imgProps.width));
        console.log("Finished attaching elevation image");
    })
    .catch(function (error) {
        console.error('oops, something went wrong! (elevation)', error);
    });
};